import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Chip } from '@mui/material'
import cn from 'classnames'
import React, { useEffect } from 'react'

const SelectionField = ({
    options,
    onChange,
    value,
    values,
    multiSelect,
    widthClassName = '',
    center = false,
    size = 'small',
    padding: paddingClassName = 'p-3',
}) => {
    const numOptions = options ? options.length : 0

    useEffect(() => {}, [numOptions])

    return (
        <div
            className={cn('relative h-auto', widthClassName, paddingClassName)}
        >
            <div
                className={cn('flex flex-wrap', {
                    'justify-center': center,
                    'justify-left': !center,
                })}
            >
                {options &&
                    options.map((option) => (
                        <div className="m-1">
                            {multiSelect &&
                            values &&
                            values.includes(option.value) ? (
                                // Multi select, e.g. tag suggesting - item is selected

                                <Chip
                                    size={size}
                                    variant="filled"
                                    label={option.label}
                                    onDelete={() => onChange(option)}
                                    onClick={() => onChange(option)}
                                    sx={{
                                        fontWeight: 'large',
                                        fontSize: 18,
                                    }}
                                    color={
                                        values && values.includes(option.value)
                                            ? 'primary'
                                            : 'default'
                                    }
                                />
                            ) : multiSelect &&
                              !(values && values.includes(option.value)) ? (
                                // Multi select, e.g. tag suggesting - item is not selected

                                <Chip
                                    size={size}
                                    variant="outlined"
                                    label={option.label}
                                    onClick={() => onChange(option)}
                                    sx={{
                                        fontWeight: 'semibold',
                                    }}
                                    color={
                                        values && values.includes(option.value)
                                            ? 'primary'
                                            : 'default'
                                    }
                                    icon={<AddCircleIcon />}
                                />
                            ) : (
                                // Individual select, e.g. category selection
                                <Chip
                                    size={size}
                                    variant={
                                        value && value.value === option.value
                                            ? 'filled'
                                            : 'outlined'
                                    }
                                    label={
                                        option.label.length > 30
                                            ? `${option.label.substring(
                                                  0,
                                                  30,
                                              )}...`
                                            : option.label
                                    }
                                    onClick={() => onChange(option)}
                                    sx={{
                                        fontWeight: 'semibold',
                                    }}
                                    color={
                                        value &&
                                        value.value === option.value &&
                                        value.value !== 'blacklisted'
                                            ? 'primary'
                                            : value &&
                                              value.value === option.value &&
                                              value.value === 'blacklisted'
                                            ? 'error'
                                            : 'default'
                                    }
                                />
                            )}
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default SelectionField
